export const STATUS_RENCANA_AKSI = {
  DRAFT: 'Draf',
  PEMENUHAN_KELENGKAPAN_DOKUMEN: 'Pemenuhan Kelengkapan Dokumen Persiapan',
  MENUNGGU_DATA_PEMRAKARSA: 'Menunggu Data Pemrakarsa',
  SIAP_DINILAI: 'Siap Dinilai',
}

// status yang membuat form penilaian pelaksanaan menjadi readonly
export const STATUS_READONLY = [STATUS_RENCANA_AKSI.SIAP_DINILAI]

export function isReadonlyStatus(status) {
  return STATUS_READONLY.includes(status)
}
